import { render, staticRenderFns } from "./LinhaDeParcelasResumo.vue?vue&type=template&id=2bbbcb84&scoped=true"
import script from "./LinhaDeParcelasResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeParcelasResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeParcelasResumo.vue?vue&type=style&index=0&id=2bbbcb84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbcb84",
  null
  
)

export default component.exports